import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type PreRegisterService from '../services/pre-register';
import type RouterService from '@ember/routing/router-service';
import type SessionService from '../services/session';
import { isLandingPageShown } from '../utils/landing-page';

export default class WelcomeRoute extends Route {
  @service declare preRegister: PreRegisterService;
  @service declare router: RouterService;
  @service declare session: SessionService;

  beforeModel() {
    // Same rule as the login route: a signed-in visitor goes into the app; a
    // mid-post-login (MFA/terms) session still needs the sign-in pages.
    if (this.session.isAuthenticated && !this.session.data.authenticated?.noTransitionAfterAuth) {
      this.session.prohibitAuthentication('authenticated.dashboard');
      return;
    }

    if (!isLandingPageShown(this.preRegister.settings?.landingPage)) {
      this.router.transitionTo('/login');
    }
  }
}
